<template>
    <div style="display: none;">
        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
            <div class="page" ref="dataprint" style="position: relative; width: 1000px; min-height: 1294px; background: white; margin: 0 auto; margin-bottom: 20px;">
                <div class="subpage" style="height: 1000px; padding-top: 20px; overflow: hidden;">
                    <div style="margin-left: 80px; margin-right: 50px;">
                        <div style="width: 100%;">
                            <table style="font-size: 12px; border-collapse: collapse; width: 100% !important;">
                                <tr><td colspan="5" style="text-align: center;"><h2>DOCUMENTO TRIBUTARIO ELECTRÓNICO</h2></td></tr>
                                <tr><td colspan="5" style="text-align: center;"><h1>COMPROBANTE CONTABLE DE LIQUIDACIÓN</h1></td></tr>
                                <tr><td colspan="5"><hr /></td></tr>
                                <tr>
                                    <td style="padding: 0 10px 5px 10px; width: 20%;"><b>Código Generación:</b></td>
                                    <td style="padding: 0 10px 5px 10px; width: 20%;">{{ dataProps.IdentificacionCodigoGeneracion }}</td>
                                    <td rowspan="3" style="padding: 0 10px 5px 10px; width: 20%;"><img ref="qrcode"/></td>
                                    <td style="padding: 0 10px 5px 10px; width: 20%;"><b>Modelo de facturación:</b></td>
                                    <td style="padding: 0 10px 5px 10px; width: 20%;">
                                        {{ dataProps.IdentificacionTipoModelo == 1 ? "Previo" : "" }}
                                        {{ dataProps.IdentificacionTipoModelo == 2 ? "Diferido" : "" }}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding: 0 10px 5px 10px;"><b>Número de Control:</b></td>
                                    <td style="padding: 0 10px 5px 10px;">{{ dataProps.IdentificacionNumeroControl }}</td>
                                    <td style="padding: 0 10px 5px 10px;"><b>Tipo de Transmisión:</b></td>
                                    <td style="padding: 0 10px 5px 10px;">{{ dataProps.IdentificacionTipoOperacion ? 'NORMAL' : 'CONTINGENCIA' }}</td>
                                </tr>
                                <tr>
                                    <td style="padding: 0 10px 5px 10px;"><b>Sello de recepción:</b></td>
                                    <td style="padding: 0 10px 5px 10px;">{{ dataProps.SelloRecibido }}</td>
                                    <td style="padding: 0 10px 5px 10px;"><b>Fecha y hora de generación:</b></td>
                                    <td style="padding: 0 10px 5px 10px;">{{ `${dataProps.IdentificacionFecEmi} ${dataProps.IdentificacionHorEmi}` }}</td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <div style="width: 100%;">
                            <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr><td colspan="6" style="text-align: center;"><h2>AGENTE DE PERCEPTOR (Emisor)</h2></td></tr>
                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre o Razón Social:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.EmisorNombre }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre comercial:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.EmisorNombreComercial }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>NIT:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ applyNitMaskHandlingHomologationOutOfInput(dataProps.EmisorNit) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>NRC:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ applyDUIMaskOutOfInput(dataProps.EmisorNrc) }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Actividad Económica:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorDescActividad }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Dirección:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorDireccionComplemento }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Número de Teléfono:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorTelefono }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Correo Electrónico:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.EmisorCorreo }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Tipo de Establecimiento:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">
                                            {{ dataProps.EmisorTipoEstablecimiento === "01" ? "Sucursal Agencia" : "" }}
                                            {{ dataProps.EmisorTipoEstablecimiento === "02" ? "Casa Matriz" : "" }}
                                            {{ dataProps.EmisorTipoEstablecimiento === "04" ? "Bodega" : "" }}
                                            {{ dataProps.EmisorTipoEstablecimiento === "07" ? "Predio y/o patio" : "" }}
                                            {{ dataProps.EmisorTipoEstablecimiento === "20" ? "Otro" : "" }}
                                        </td>
                                    </tr>
                                </div>
                            </table>
                            <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr><td colspan="6" style="text-align: center;"><h2>AFILIADO (Receptor)</h2></td></tr>
                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre o Razón Social:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ReceptorNombre }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>NIT:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ applyNitMaskHandlingHomologationOutOfInput(dataProps.ReceptorNit) }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>NRC:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ applyDUIMaskOutOfInput(dataProps.ReceptorNrc) }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Actividad Económica:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorDescActividad }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Nombre Comercial:</b></td>
                                        <td colspan="3" style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorNombreComercial }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Dirección:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorDireccionComplemento }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Correo Electrónico:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.ReceptorCorreo }}</td>
                                    </tr>
                                </div>
                            </table>
                            <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <tr><td colspan="6" style="text-align: center;"><h2>DOCUMENTO</h2></td></tr>
                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Fecha inicio del periodo de liquidación:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.CuerpoDocumentoDclPerLiqFeInicio }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Fecha fin del periodo de liquidación:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.CuerpoDocumentoDclPerLiqFeFin }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Valor de las operaciones a liquidar:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">${{ dataProps.CuerpoDocumentoDclValorOperaciones }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Cantidad de documentos de liquidación:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.CuerpoDocumentoDclCantidadDoc }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Descripción del monto no sujeto a percepción:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">{{ dataProps.CuerpoDocumentoDclDescripSinPer }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Comisión:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclComision }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Valores no sujetos a percepción:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclMontoSinPer }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Porcentaje comisión:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclPorcentComision }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Subtotal:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclSubTotal }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>IVA de la comisión:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclIvaComision }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>IVA de las operaciones a liquidar:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclIva }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>Valor liquido a pagar al afiliado:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclLiquidoPagar }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Montos sujetos a percepción sin IVA:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclMontoSujPer }}</td>
                                        <td style="padding: 0 10px 5px 10px;"><b>IVA Percibido:</b></td>
                                        <td style="padding: 0 10px 5px 10px;">${{ dataProps.CuerpoDocumentoDclIvaPercibido }}</td>
                                    </tr>
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px;"><b>Valor en letras:</b></td>
                                        <td colspan="5" style="padding: 0 10px 5px 10px;">{{ dataProps.CuerpoDocumentoDclTotalLetras }}</td>
                                    </tr>
                                </div>
                            </table>
                            <table style="width: 100% !important; font-size: 11px; margin-top: 40px;">
                                <div style="border-collapse: collapse; border: 1px solid black;">
                                    <tr>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Nombre del responsable de la liquidación:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ExtensionNombEntrega }}</td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;"><b>Documento del responsable:</b></td>
                                        <td style="padding: 0 10px 5px 10px; width: 16.66666666666667%;">{{ dataProps.ExtensionDocuEntrega }}</td>
                                    </tr>
                                </div>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsPDF from "jspdf";
import QRCode from 'qrcode';
import {
    applyDUIMaskOutOfInput,
    applyNitMaskHandlingHomologationOutOfInput
} from "../../helpers/masks";

export default {
    name: "PrintLiquidacionesHidden",
    props: {
        dataProps: {
            type: Object,
            required: true,
        },
    },
    methods: {
        applyDUIMaskOutOfInput(value) {
            return applyDUIMaskOutOfInput(value);
        },
        applyNitMaskHandlingHomologationOutOfInput(value) {
            return applyNitMaskHandlingHomologationOutOfInput(value);
        },
        async setupQr() {
            const { IdentificacionAmbiente, IdentificacionCodigoGeneracion, IdentificacionFecEmi } = this.dataProps;
            const url = `https://admin.factura.gob.sv/consultaPublica?ambiente=${IdentificacionAmbiente}&codGen=${IdentificacionCodigoGeneracion}&fechaEmi=${IdentificacionFecEmi}`;
            const opt = {
                errorCorrectionLevel: 'H',
                type: 'image/png',
                quality: 0.3,
                margin: 1,
                color: {
                    dark:"#000000",
                    light:"#ffffff"
                },
                width: 100
            };

            return new Promise((resolve, reject) => {
                QRCode.toDataURL(url, opt, (error, qrUrl) => {
                    if (error) {
                        reject(error);
                        return;
                    }

                    this.$refs.qrcode.src = qrUrl;
                    resolve();
                });
            });
        },
        async buildPdfDocument() {
            const doc = new jsPDF('p', 'pt', 'letter');
            await doc.html(this.$refs.dataprint, {
                callback: function(generatedDoc) {
                    generatedDoc.output();
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas: {
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });

            doc.deletePage(2);
            return doc;
        },
        getFilename() {
            const invoiceId = this.dataProps.ID_Invoice || 'comprobante';
            const numeroControl = String(this.dataProps.IdentificacionNumeroControl || '').replace(/[\\/:*?"<>|]/g, '');
            return `${invoiceId}_${numeroControl || this.dataProps.IdentificacionCodigoGeneracion}.pdf`;
        },
        async generatePdfBlob() {
            await this.$nextTick();
            await this.setupQr();
            await this.$nextTick();

            const doc = await this.buildPdfDocument();
            return {
                blob: doc.output('blob'),
                filename: this.getFilename(),
            };
        },
    }
}
</script>
